import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 'proposalState',
})
export class ProposalStatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: unknown, ...args: unknown[]): unknown {
    return this.translate.s('state_' + value, 'pipe');
  }
}
